import { render, staticRenderFns } from "./CaregiverTaskDetail.vue?vue&type=template&id=39ae0542&scoped=true&"
import script from "./CaregiverTaskDetail.vue?vue&type=script&lang=js&"
export * from "./CaregiverTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./CaregiverTaskDetail.vue?vue&type=style&index=0&id=39ae0542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae0542",
  null
  
)

export default component.exports